/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SortType = {
    asc: 'asc',
    desc: 'desc'
} as const;
export type SortType = typeof SortType[keyof typeof SortType];

